import React from 'react'

import { useBrandGraphic } from '../../../../Designs/blocs/brandResolvers'
import type { IndexedElement } from '../../../../firebase/model/mix'
import { ElementPositioner } from '../ElementPositioner/ElementPositioner'

import './GraphicElement.scss'

interface GraphicElementProps {
  element: IndexedElement & { type: 'graphic' }
}

const GraphicElement = ({ element }: GraphicElementProps) => {
  const resolveBrandGraphic = useBrandGraphic()

  const backgroundImage = resolveBrandGraphic(element.style?.backgroundImage)

  return (
    <ElementPositioner element={element}>
      <div
        className="graphic-element"
        style={{
          backgroundImage: backgroundImage
            ? `url(${backgroundImage})`
            : undefined,
          backgroundSize: element.fit,
          '--border-radius-top-left': element.radius?.topLeft,
          '--border-radius-top-right': element.radius?.topRight,
          '--border-radius-bottom-left': element.radius?.bottomLeft,
          '--border-radius-bottom-right': element.radius?.bottomRight,
        }}
      />
    </ElementPositioner>
  )
}

export { GraphicElement }
